import request from '@/libs/request'

// 牛场屠宰 静养圈 列表
export function cattleSlaughterRestListApi (data) {
  return request({
    url: `cattleFarm/cattleSlaughterRest`,
    method: 'get',
    params: data
  })
}

// 牛场屠宰 静养圈 详情
export function cattleSlaughterRestDetailApi (id) {
  return request({
    url: `cattleFarm/cattleSlaughterRest/` + id,
    method: 'get'
  })
}


// 牛场屠宰 静养圈 编辑/添加
export function cattleSlaughterRestSaveApi (data) {
  return request({
    url: `cattleFarm/cattleSlaughterRest`,
    method: 'post',
    data: data
  })
}

// 牛场屠宰 静养圈 删除
export function cattleSlaughterRestDelApi (id) {
  return request({
    url: `cattleFarm/cattleSlaughterRest/` + id,
    method: 'delete'
  })
}

//牛场屠宰 静养圈 所有数据
export function cattleSlaughterRestAllApi (data = {}) {
  return request({
    url: `cattleFarm/cattleSlaughterRestApi/all`,
    method: 'get',
    params: data
  })
}


